<app-header></app-header>
<app-back-button class="block mb-lg"></app-back-button>
<app-page-title>{{ 'bvg.title' | translate }}</app-page-title>
<app-common-spacer></app-common-spacer>
<app-html-content [text]="'articles.bvg_entire_article_html' | translate"></app-html-content>
<div class="mt-3xl"></div>
<app-content-sections></app-content-sections>
<div class="mt-3xl"></div>
<app-footer-info></app-footer-info>
